/**
 * Set filters in state based on inputs
 *
 * @param {*} state
 * @param {*} tagsInput
 * @param {*} projectInputs
 * @param {*} groupInputs
 * @param {*} resetButton
 */

import {
    searchInput,
    projectInputs,
    groupInputs,
    resetFilterBtn,
    allProjects,
    allGroups,
} from '../options';

export function setFilter(state, tagsInput) {
    state.projects = [];
    state.groups = [];
    state.tags = [];

    state.searchTerm = searchInput.value;

    state.selected.tags = tagsInput.value;
    state.selected.projects = document.querySelectorAll(
        '.form-check-project:checked'
    );
    state.selected.groups = document.querySelectorAll(
        '.form-check-group:checked'
    );

    // Check if any filter has been set
    state.isSet.search = state.searchTerm !== '';
    const allProjectsChecked =
        state.selected.projects.length === projectInputs.length;
    state.isSet.projects =
        state.selected.projects.length !== projectInputs.length;
    const allGroupsChecked =
        state.selected.groups.length === groupInputs.length;
    const noGroupsChecked = state.selected.groups.length === 0;
    state.isSet.groups = !noGroupsChecked || allGroupsChecked;
    state.isSet.tags = state.selected.tags.length !== 0;

    state.filterActive =
        state.isSet.projects ||
        state.isSet.groups ||
        state.isSet.tags ||
        state.isSet.search;

    // Set filter state if filter has been set
    if (state.filterActive) {
        for (let project of state.selected.projects) {
            state.projects.push(project.value);
        }
        for (let group of state.selected.groups) {
            state.groups.push(group.value);
        }
        for (let tag of state.selected.tags) {
            state.tags.push(tag.value);
        }
    }

    // Set state of catch-all checkboxes
    allProjects.checked = allProjectsChecked;
    allGroups.checked = allGroupsChecked;

    // Enable reset button if a filter has been set
    resetFilterBtn.disabled = !state.filterActive;
}
